import {
  Container,
  Heading,
  Text,
  Stack,
  Box,
  Button,
  Icon,
} from "@chakra-ui/react";
import NextLink from "next/link";
import { FiArrowRight } from "react-icons/fi";

export default function CTASection() {
  return (
    <Box w="full" bg="#0a0f1a" py={{ base: 20, md: 28 }}>
      <Container maxW="4xl">
        <Stack spacing={8} textAlign="center" align="center">
          <Heading
            color="white"
            fontWeight={800}
            fontSize={{ base: "3xl", sm: "4xl", md: "5xl", lg: "6xl" }}
            lineHeight="1.2"
            letterSpacing="-0.02em"
          >
            Ready to Adventure
            <br />
            <Text as="span" color="brand.500">
              With Confidence?
            </Text>
          </Heading>

          <Text
            color="text.on-black-secondary"
            fontSize={{ base: "lg", md: "xl" }}
            maxW="2xl"
            lineHeight="1.8"
          >
            Join thousands of adventurers who trust Adiona Alert to keep them
            informed and safe, no matter where their journey takes them.
          </Text>

          <Stack direction={{ base: "column", sm: "row" }} spacing={4} pt={4}>
            <Button
              as={NextLink}
              href="/login"
              bg="brand.500"
              color="white"
              px={10}
              py={7}
              fontSize="lg"
              fontWeight={600}
              borderRadius="md"
              rightIcon={<Icon as={FiArrowRight} aria-hidden="true" />}
              _hover={{
                bg: "brand.800",
                transform: "translateY(-1px)",
                textDecoration: "none",
              }}
              transition="background-color 0.2s ease, transform 0.2s ease"
            >
              Start Free Today
            </Button>
            <Button
              as={NextLink}
              href="/pricing"
              bg="transparent"
              color="white"
              px={10}
              py={7}
              fontSize="lg"
              fontWeight={600}
              borderRadius="md"
              border="1px solid rgba(255, 255, 255, 0.2)"
              _hover={{
                bg: "rgba(255, 255, 255, 0.05)",
                borderColor: "rgba(255, 255, 255, 0.4)",
                textDecoration: "none",
              }}
              transition="background-color 0.2s ease, border-color 0.2s ease"
            >
              View Pricing
            </Button>
          </Stack>

          <Text color="text.on-black-muted" fontSize="sm" pt={4}>
            14-day money-back guarantee • Cancel anytime
          </Text>
        </Stack>
      </Container>
    </Box>
  );
}
